<template>
  <div>
    <div>
      <div @click="applyResult" class="item" :class="{ isSelected }">
        {{ description }}
      </div>
    </div>
  </div>
</template>

<script>
import { actions } from '@/vuex/modules/pointGroupOperation/constants'

export default {
  name: 'AutoCompleteItem',
  props: { item: Object, isSelected: Boolean },
  computed: {
    description() {
      // 行頭の「日本、」を除去する
      return this.item.description.replace(/日本、/, '')
    },
  },
  methods: {
    applyResult() {
      this.$store.dispatch(actions.APPLY_SEARCH_RESULT, { result: this.item })
    },
  },
}
</script>

<style scoped lang="scss">
.item {
  cursor: pointer;
  padding: 2px 10px;
  font-size: 12px;
  transition: background-color 0.1s;
  &:hover {
    background: #c8dbff;
  }
  &.isSelected {
    background-color: #c8dbff;
  }
}
</style>
